<script>
	import { ArticleV4, OtherArticlesV4 } from '$lib/modules/blog'
	import { WOLTADVISOR, PHOTOVOLTAICS, CONTACT } from '$lib/routes'
	import { BoxLinks, FAQ, HeaderHero, IconedBoxes, OrderedList } from '$lib/ui-woltair/components'

	const header = {
		heading: 'web.charging_station.header.title',
		subheading: 'web.charging_station.header.subtext',
		main_image: {
			url: '/images/illustrations/house-photovoltaics.svg',
			alt: ''
		},
		button: [
			{
				text: 'web.charging_station.header.button1.text',
				url: `/${PHOTOVOLTAICS}/${WOLTADVISOR}`,
				icon: {
					url: '/images/icons/icon-calculator.svg',
					alt: 'web.charging_station.header.button1.imageAlt'
				}
			},
			{
				text: 'web.charging_station.header.button2.text',
				url: `/${CONTACT}`,
				gray: true,
				icon: {
					url: '/images/avatars/team.webp',
					alt: 'web.charging_station.header.button2.imageAlt'
				}
			}
		]
	}

	export const boxes = [
		{
			title: {
				text: 'web.charging_station.boxes.box1.title'
			},
			description: 'web.charging_station.boxes.box1.description',
			icon: {
				src: '/images/icons/simple/meter.svg',
				alt: 'web.charging_station.boxes.box1.imageAlt'
			}
		},
		{
			title: {
				text: 'web.charging_station.boxes.box2.title'
			},
			description: 'web.charging_station.boxes.box2.description',
			icon: {
				src: '/images/icons/simple/chair.svg',
				alt: 'web.charging_station.boxes.box2.imageAlt'
			}
		},
		{
			title: {
				text: 'web.charging_station.boxes.box3.title'
			},
			description: 'web.charging_station.boxes.box3.description',
			icon: {
				src: '/images/icons/simple/shield.svg',
				alt: 'web.charging_station.boxes.box3.imageAlt'
			}
		},
		{
			title: {
				text: 'web.charging_station.boxes.box4.title'
			},
			description: 'web.charging_station.boxes.box4.description',
			icon: {
				src: '/images/icons/simple/arrow.svg',
				alt: 'web.charging_station.boxes.box4.imageAlt'
			}
		}
	]

	const boxLinks = [
		{
			title: 'web.charging_station.boxLinks.box1.title',
			subtext: 'web.charging_station.boxLinks.box1.subtext',
			button_text: 'web.charging_station.boxLinks.box1.buttonText',
			button_url: `/${PHOTOVOLTAICS}/${WOLTADVISOR}`,
			image: {
				url: '/images/devices/IONT.webp',
				alt: 'web.charging_station.boxLinks.box1.image.alt'
			}
		}
	]

	const content = {
		title: 'web.charging_station.list.title',
		list: [
			{
				title: 'web.charging_station.list.1.title',
				list: 'web.charging_station.list.1.text'
			},
			{
				title: 'web.charging_station.list.2.title',
				list: 'web.charging_station.list.2.text'
			},
			{
				title: 'web.charging_station.list.3.title',
				list: 'web.charging_station.list.3.text'
			},
			{
				title: 'web.charging_station.list.4.title',
				list: 'web.charging_station.list.4.text'
			}
		]
	}

	export let data
</script>

<HeaderHero {header} />
<section class="page-wrapper mt-4 grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3">
	<div class="md:col-span-2">
		<IconedBoxes {boxes} subtext cls="mt-5 grid md:grid-cols-2" />
	</div>
	<div class="col-span-1">
		<BoxLinks gridsize="1" {boxLinks} />
	</div>
</section>
<section class="page-wrapper">
	<OrderedList {content} />
</section>
{#if data.article}
	<section class="mx-auto max-w-[800px] px-4">
		<ArticleV4 article={data.article} />
	</section>
{/if}
{#if data.faqs}
	<section class="page-wrapper relative mt-24">
		<FAQ faqs={data.faqs} />
	</section>
{/if}
{#if data.otherArticles}
	<section class="page-wrapper">
		<OtherArticlesV4 otherArticles={data.otherArticles} />
	</section>
{/if}

<style>
	:global(.col-span-1 > .boxes) {
		display: block;
	}
</style>
